/* eslint-disable no-console */
import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader/Preloader';
import useAuth0WithRedux from '../../auth/useAuth0WithRedux';

function LogoutPage() {
  const { logout } = useAuth0WithRedux();
  // const location = useLocation();
  // const dispatch = useDispatch();

  useEffect(() => {
    try {
      // const redirectPath = location.state?.locationFrom || '/';
      // localStorage.setItem('loginRedirect', redirectPath);
      // dispatch(resetApplicationStore()); // Now handled in useAuth0WithRedux

      logout();
    } catch (error) {
      console.log('logout error', error);
      // navigate('/', { replace: true });
    }
  }, []);

  return <Preloader />;
}

export default LogoutPage;
